/**
 * Gets the top-level domain from the current hostname.
 * If the hostname is localhost or has no TLD, defaults to 'securesurfnet.com'
 * 
 * @returns {string} The domain to use (e.g., 'example.com' or 'vpn111.com')
 */
export function getDomain() {
  const hostname = window.location.hostname;
  
  // Handle localhost or IP addresses
  if (hostname === 'localhost' || hostname === '127.0.0.1' || !hostname.includes('.')) {
    return 'securesurfnet.com';
  }
  
  // Extract top-level domain
  // For 'app.example.com' -> 'example.com'
  // For 'subdomain.example.co.uk' -> 'example.co.uk' (takes last 2-3 parts)
  const parts = hostname.split('.');
  
  // If we have at least 2 parts, take the last 2 (domain.tld)
  // For common multi-part TLDs like .co.uk, we'd need more logic,
  // but for now we'll take the last 2 parts which covers most cases
  if (parts.length >= 2) {
    return parts.slice(-2).join('.');
  }
  
  // Fallback to default
  return 'securesurfnet.com';
}
